import api from "./api.js";

export default class MemberApi {
  static async getMyInfo() {
    return await api.get(`api/member/my/info`);
  }

  // 내 정보 수정
  static async updateMyInfo(data, headers) {
    return await api.patch(`api/member/my/info`, data, headers);
  }
}
